<template>
    <div class="trigger-preview">
        <div>
            <div class="messages">
                <div
                    class="message"
                    v-for="(message, i) in getMessageList()"
                    v-animate-css="'fadeInRight'"
                    v-show="i <= cursor"
                >
                    <span>{{ message }}</span>
                </div>
            </div>
            <div class="bubble">
                <BubblePreview />
            </div>
        </div>
    </div>
</template>

<script>
import BubblePreview from "../fast-initialize/BubblePreview";
import Vue from "vue";

import VAnimateCss from "v-animate-css";
import _ from "lodash";
import log2 from "../../utils/log2";
import { Howl } from "howler";
import { mapState } from "vuex";

const sound = new Howl({
    src: [`./static/media/ogg_folder/exquisite.ogg`],
    autoplay: false,
    loop: false,
    volume: 0.1,
    //onend: () => console.log('newMessageSound Finished!'),
    onplayerror: (ex) => console.error("trigger sound error!", ex),
});
Vue.use(VAnimateCss);
const log = log2("TriggerPreview");
export default {
    name: "TriggerPreview",
    components: {
        BubblePreview,
    },
    props: {
        trigger: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            cursor: 0,
            selectedTrigger: JSON.parse(JSON.stringify(this.trigger)),
        };
    },
    computed: {
        ...mapState({
            userInteracted: (state) => state.app.userInteracted,
        }),
    },
    methods: {
        escapeHtml(message) {
            let parser = new DOMParser();
            let dom = parser.parseFromString("<!doctype html><body>" + message, "text/html");
            return dom.body.textContent;
        },
        getMessageList() {
            let currentLangMessage;
            let html;
            if (!(this.selectedTrigger.message.length >= 3)) {
                currentLangMessage = this.selectedTrigger.message[this.$i18n.locale] || "";
                html = currentLangMessage.replace(/\<\/?.*?\>/gi, "\n");
            } else {
                log(" selectedTrigger message", this.selectedTrigger.message);
                currentLangMessage = this.selectedTrigger.message.find((x) => x.code === this.$i18n.locale);
                html = _.get(currentLangMessage, "content", "");
                if (html.length < 1 || html === " ") {
                    html = this.$t("message.noContent");
                }
                html = html.replace(/\<\/?.*?\>/gi, "\n");
            }

            let plainMessageText = this.escapeHtml(html);

            let messageList = plainMessageText
                .split("\n")
                .filter((x) => x.length > 0)
                .map((y) => y.replace("&nbsp;", " "));

            log("getMessageList", {
                cur: this.selectedTrigger.message,
                currentLangMessage,
                html,
                plainMessageText,
                messageList,
            });
            return messageList;
        },
    },
    mounted() {
        log("mounted", this.selectedTrigger.message);
        const messages = this.getMessageList();
        this.timerId = setInterval(() => {
            if (this.userInteracted) {
                sound.play();
            }
            this.cursor++;
            if (this.cursor >= messages.length) {
                clearInterval(this.timerId);
            }
        }, 1000);
    },
    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },
    watch: {
        cursor(newValue) {
            if (newValue === this.getMessageList().length) {
                let self = this;
                setTimeout(() => {
                    self.selectedTrigger = undefined;
                    self.$emit("trigger-end", this.selectedTrigger);
                }, 1000);
            }
        },
        trigger: {
            deep: true,
            handler(newValue, oldValue) {
                if (newValue) {
                    this.cursor = 0;
                }
            },
        },
    },
};
</script>

<style lang="scss">
.trigger-preview {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: auto;
    height: auto;

    width: 600px;
    height: 400px;

    .bubble {
        display: flex;
        justify-content: flex-end;
    }

    .messages {
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        overflow: hidden;
        padding-right: 10px;

        .message {
            background: #ffffffbf;
            border-radius: 12px;
            color: #000000;
            margin: 12px 0px;
            box-shadow: 2px 3px 6px #00000070;
            cursor: pointer;
            max-height: 100%;
            padding: 8px 16px;
            max-width: 500px;
            font-weight: 300;
            user-select: none;
            overflow: hidden;
        }
    }
}
</style>
